export interface StringColumnProps {
  strings: string[];
}

const StringColumn: React.FunctionComponent<StringColumnProps> = function ({
  strings,
}) {
  return (
    <div className="flex flex-col gap-y-1 text-left">
      {strings.map((str) => (
        <p key={str}>{str}</p>
      ))}
    </div>
  );
};

export default StringColumn;
